var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18882 16.8H5.27532L9.44827 15.8919C9.52955 15.8783 9.60487 15.8407 9.66447 15.7838L16.7347 8.71355C17.2511 8.19818 17.5393 7.49721 17.5347 6.76763C17.5356 6.03239 17.2484 5.32607 16.7347 4.80007C16.2193 4.28359 15.5184 3.99543 14.7887 4.0001C14.0545 3.99361 13.3502 4.29096 12.8428 4.82172L5.7942 11.8919C5.73204 11.9419 5.68672 12.0099 5.66446 12.0865L4.75639 16.2595C4.7316 16.4093 4.77977 16.5619 4.88613 16.6703C4.96596 16.7517 5.07476 16.7984 5.18882 16.8ZM14.7887 4.86496C15.8276 4.86488 16.6698 5.70702 16.6699 6.74591C16.6699 6.75315 16.6699 6.76039 16.6698 6.76763C16.6769 7.26255 16.4816 7.73894 16.1293 8.08653L13.4698 5.40545C13.8202 5.05728 14.2948 4.86277 14.7887 4.86496ZM12.8644 6.03251L15.5239 8.69195L9.36174 14.8324L6.70231 12.1946L12.8644 6.03251ZM6.35637 13.0595L8.49688 15.2L5.75095 15.8054L6.35637 13.0595Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9188 19.1351H4.43243C4.1936 19.1351 4 19.3287 4 19.5675C4 19.8064 4.1936 20 4.43243 20H18.9188C19.1577 20 19.3513 19.8064 19.3513 19.5675C19.3513 19.3287 19.1577 19.1351 18.9188 19.1351Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4e860bef21ac15f441260a9707ec0b9d.svg";
export { ForwardRef as ReactComponent };